import { buildProps as e } from "./index601.js";
const o = e({
  always: {
    type: Boolean,
    default: !0
  },
  minSize: {
    type: Number,
    required: !0
  }
});
export {
  o as barProps
};
